module.exports = __webpack_public_path__ + "static/img/about_introduce_01_zh_h5.9a866db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/about_introduce_01_zh_h5.png
// module id = FF+T
// module chunks = 34